import React from "react";

export default function UploadInitPopup({ closeToast, onBackToInitiatives }) {
  const handleClose = () => {
    closeToast(); // Close the toast when "OK" is clicked
    // Call the callback function to navigate
    if (onBackToInitiatives) {
        onBackToInitiatives();
    }
  };

  return (
    <div>
      <div className="">
        <div id="">
          <div id="">
            <p className="popUpText">
            Your CSV file has been uploaded!
            </p>
            <button className="alert_button" onClick={handleClose}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
